<template>
    <div class="wrap">
        <SectionTitle text="New Arrival" class="title" />

        <ul class="newArrival">
            <li v-for="(item, index) in newArrival" :key="index">
                <a :href="switchItemURL(item)" v-on="canHover ? hoverHandlers(item, index) : {}">
                    <img :src="thumbSrc(item)" :data-first-thumb="item.first_thumb || '0'" :data-second-thumb="item.second_thumb || '00'" alt="" class="img" v-show="!item.gif" ref="itemImages" />
                    <img :src="`https://thumbnail.image.rakuten.co.jp/@0_mall/auc-rodeo/cabinet/${item.image}-0.gif`" alt="" class="img" v-if="item.gif" />

                    <div class="brand">{{ item.brand }}</div>
                    <div class="price">{{ taxIn(item.price) }}</div>
                </a>
            </li>
        </ul>

        <MoreLink to="/new" text="MORE" />
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import MoreLink from '@/components/MoreLink.vue'

export default {
  name: 'NewArrival',
  components: { SectionTitle, MoreLink },

  data () {
    return {
      windowWidth: (typeof window !== 'undefined') ? window.innerWidth : 1524, // 表示件数計算用の現在幅
      canHover: false // PC等ホバー可能端末のみ true
    }
  },

  computed: {
    // 画面幅に応じた表示件数
    newArrivalCount () {
      const w = this.windowWidth
      if (w <= 722) return 20 // @media screen and (max-width: 722px)
      if (w <= 963) return 21 // @media screen and (min-width: 723px) and (max-width: 963px)
      if (w <= 1523) return 20 // @media screen and (min-width: 964px) and (max-width: 1523px)
      if (w <= 2286) return 20 // @media screen and (min-width: 1524px) and (max-width: 2286px)
      return 20 // @media screen and (min-width: 2287px)
    },

    // NEWグループだけを指定件数まで抽出
    newArrival () {
      const rtn = []
      const newJson = this.$store.state.json.new
      for (let i = 0; i < newJson.length; i++) {
        if (newJson[i].group === 'NEW') rtn.push(newJson[i])
        if (rtn.length === this.newArrivalCount) break
      }
      return rtn
    }
  },

  methods: {
    // 初期表示用サムネURL（first_thumb優先）
    thumbSrc (item) {
      const first = item.first_thumb || '0'
      return `https://thumbnail.image.rakuten.co.jp/@0_mall/auc-rodeo/cabinet/${item.image}-${first}.jpg`
    },

    // 1枚目/2枚目サムネURL生成
    thumbUrl (item, which) {
      const first = item.first_thumb || '0'
      const second = item.second_thumb || '00'
      const thumb = (which === 'second') ? second : first
      return `https://thumbnail.image.rakuten.co.jp/@0_mall/auc-rodeo/cabinet/${item.image}-${thumb}.jpg`
    },

    // hover可能時のみ mouseenter/leave を付与
    hoverHandlers (item, index) {
      return {
        mouseenter: () => this.itemMouseOver(item, index),
        mouseleave: () => this.itemMouseOut(item, index)
      }
    },

    // ホバーで2枚目へ切替（GIF/スマホは対象外）
    itemMouseOver (item, index) {
      if (!this.canHover || item.gif) return
      const imgDom = this.$refs.itemImages && this.$refs.itemImages[index]
      if (!imgDom) return
      imgDom.src = this.thumbUrl(item, 'second')
    },

    // ホバー解除で1枚目へ戻す
    itemMouseOut (item, index) {
      if (!this.canHover || item.gif) return
      const imgDom = this.$refs.itemImages && this.$refs.itemImages[index]
      if (!imgDom) return
      imgDom.src = this.thumbUrl(item, 'first')
    },

    // hover可能端末か判定（スマホでのhover誤動作を回避）
    updateCanHover () {
      this.canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)
    }
  },

  mounted () {
    this._onResize = () => { this.windowWidth = window.innerWidth } // 画面幅変更を監視
    window.addEventListener('resize', this._onResize, { passive: true })

    this._onHoverChange = () => this.updateCanHover() // hover可否の変化に追従
    this.updateCanHover()

    if (window.matchMedia) {
      this._hoverMql = window.matchMedia('(hover: hover) and (pointer: fine)') // hover判定の監視
      if (this._hoverMql.addEventListener) this._hoverMql.addEventListener('change', this._onHoverChange)
      else if (this._hoverMql.addListener) this._hoverMql.addListener(this._onHoverChange)
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this._onResize) // リスナー解除
    if (this._hoverMql) {
      if (this._hoverMql.removeEventListener) this._hoverMql.removeEventListener('change', this._onHoverChange)
      else if (this._hoverMql.removeListener) this._hoverMql.removeListener(this._onHoverChange)
    }
  }
}
</script>

<style lang="scss" scoped>
.newArrival {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    text-transform: uppercase;
    border-top: 1px solid #dddddd;
    border-left: 1px solid #dddddd;

    @media screen and (max-width: 722px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 964px) and (max-width: 1523px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media screen and (min-width: 1524px) and (max-width: 2286px) {
        grid-template-columns: repeat(5, 1fr);
    }

    @media screen and (min-width: 2287px) {
        grid-template-columns: repeat(5, 1fr);
    }

    >li {
        padding: 30px;
        font-size: 13px;
        text-align: left;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;

        @media screen and (max-width: 722px) {
            padding: 15px;
            padding: 15px 15px 23px;
        }

        @media screen and (min-width: 723px) and (max-width: 963px) {}

        @media screen and (min-width: 964px) and (max-width: 1523px) {}

        @media screen and (min-width: 1524px) and (max-width: 2286px) {}

        @media screen and (min-width: 2287px) {}
    }

    .img {
        width: 100%;
    }

    .brand {
        padding: 14px 0 6px;

        @media screen and (max-width: 722px) {
            padding: 12px 0 6px;
            padding: 11px 0 4px;
            padding: 10px 0 4px;
        }
    }
}
</style>
